<div id="clock">
  <svg id="countdownclock" x="0px" y="0px" viewBox="0 0 63.333 73.333" xml:space="preserve">
    <polygon class="clockline" points="4.701,21.098 4.701,52.235 31.667,67.804 58.632,52.235 58.632,21.098 31.667,5.529 " />
  </svg>
</div>
